/**
 * variant-price-fix.js
 *
 * Patch for owlvans.com "L" / "LTA" theme.
 *
 * Problem: <l-variant-selects> dispatches `l:variant:changed` without
 * fetching the re-rendered section, so event.detail.html.location is null.
 * <l-product-price>.handleOnVariantChange then throws on `.getElementById`
 * and the displayed price never updates when a customer picks a variant.
 *
 * Fix: add our own listener for the same event. event.detail.variant.price
 * is present and correct, so we read it directly and update the DOM.
 * The broken handler still throws (silently), but our listener runs
 * independently and updates the price first.
 *
 * Also fixes initial page load price formatting using a MutationObserver
 * to intercept and correct the theme's own price rendering.
 *
 * Drop this file into theme assets and include it from layout/theme.liquid.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var dollars = cents / 100;
    var hasFraction = dollars % 1 !== 0;
    return '$' + dollars.toLocaleString('en-US', {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function updatePriceForSection(sectionId, variant) {
    if (!variant) return;

    var selector = sectionId
      ? 'l-product-price[data-section-id="' + sectionId + '"]'
      : 'l-product-price';

    document.querySelectorAll(selector).forEach(function (container) {
      var priceSpan = container.querySelector('[data-price]');
      if (priceSpan) priceSpan.textContent = formatMoney(variant.price);

      container.setAttribute('data-normal-price', String(variant.price));
      if (variant.compare_at_price) {
        container.setAttribute('data-compare-price', String(variant.compare_at_price));
      } else {
        container.setAttribute('data-compare-price', '');
      }

      if (sectionId) {
        document
          .querySelectorAll('[data-product-normal-price="' + sectionId + '"]')
          .forEach(function (el) {
            el.textContent = formatMoney(variant.price);
          });
      }
    });
  }

  function watchAndFixPrices() {
    document.querySelectorAll('l-product-price').forEach(function (container) {
      var priceSpan = container.querySelector('[data-price]');
      if (!priceSpan) return;

      // Fix immediately in case already rendered
      var price = parseInt(container.getAttribute('data-normal-price'), 10);
      if (!isNaN(price)) priceSpan.textContent = formatMoney(price);

      var comparePrice = parseInt(container.getAttribute('data-compare-price'), 10);
      var comparePriceSpan = container.querySelector('[data-compare-price]');
      if (comparePriceSpan && !isNaN(comparePrice) && comparePrice > 0) {
        comparePriceSpan.textContent = formatMoney(comparePrice);
      }

      // Watch for theme JS to overwrite and correct again immediately
      var observer = new MutationObserver(function () {
        observer.disconnect();
        var p = parseInt(container.getAttribute('data-normal-price'), 10);
        if (!isNaN(p)) priceSpan.textContent = formatMoney(p);
        observer.observe(priceSpan, { childList: true, characterData: true, subtree: true });
      });

      observer.observe(priceSpan, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAndFixPrices);
  } else {
    watchAndFixPrices();
  }

  document.addEventListener('l:variant:changed', function (event) {
    try {
      var detail = event && event.detail;
      if (!detail || !detail.variant) return;
      updatePriceForSection(detail.sectionId, detail.variant);
    } catch (err) {
      if (window && window.console) console.warn('variant-price-fix:', err);
    }
  });
})();
